export default "__VITE_ASSET__71a0c4b6__"